import React, { Component } from 'react';
import { NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ExitButton } from './Submit/ExitButton';
import { ExitModal } from './Submit/ExitModal';
import { Content } from '../infrastructure/content';
import { redirectToExit, redirectToBackScreen } from '../store/dataCapture/actions';
import { selectors as configSelectors } from '../infrastructure/config';
import { selectors as caseSelectors } from '../infrastructure/cases';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BackButton } from './Submit/BackButton';
import { ROUTE_REVIEW_PAGE } from '../utils/constants';

class SaveAndContinue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExitModalOpen: false
    };
    this.toggleExitModal = this.toggleExitModal.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  toggleExitModal() {
    this.setState({ ...this.state, isExitModalOpen: !this.state.isExitModalOpen });
  }

  handleBackClick() {
    this.props.redirectToBackScreen(ROUTE_REVIEW_PAGE, false);
  }

  render() {
    const { isExitModalOpen } = this.state;
    const {
      hideExit = false,
      exitButtonText,
      saveEnabled,
      handleExit,
      username,
      onClick
    } = this.props;

    return (
      <div>
        <NavigationButtonGroup
          tertiaryButtons={
            !hideExit &&
            ExitButton({
              onClick: this.toggleExitModal,
              saveEnabled,
              exitButtonText
            })
          }
          primaryButton={
            <NavigationButton.Primary
              labelText={<Content id="saveAndContinue" />}
              onClick={onClick}
            />
          }
          secondaryButtons={<BackButton onClick={this.handleBackClick} />}
        />

        {!hideExit &&
          ExitModal({
            toggleModal: this.toggleExitModal,
            handleExit,
            saveEnabled,
            username,
            isExitModalOpen
          })}
      </div>
    );
  }
}

const actionCreators = {
  handleExit: redirectToExit,
  redirectToBackScreen: redirectToBackScreen
};

const mapStateToProps = (state) => ({
  saveEnabled: !!configSelectors.getCaseId(state),
  username: caseSelectors.getUsername(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaveAndContinue);
